import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

class LavaMap extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.svg = this.querySelector('svg');
    this.pins = this.querySelectorAll('svg>path');

    const tl = new gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: "top center",
      }
    })
    .fromTo(this.pins,
      { opacity: 0, translateY: '-200%', },
      { opacity: 1, translateY: 0, duration: 0.4, stagger: 0.2, ease: "bounce.out" },
    );
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('lava-map', LavaMap);
}
